<template>
  <div v-if="copy">
    <h1>Email template revision</h1>
    <v-btn
      :to="{ name: 'emailTemplateSales', params: { id: $route.params.id } }"
      ><v-icon>chevron_left</v-icon> Email template</v-btn
    >
    <v-btn @click="publish" v-if="$route.params.revisionid && !copy.published"
      ><v-icon>chevron_right</v-icon>Publish</v-btn
    >
    <v-btn
      v-if="$route.params.revisionid"
      :to="{
        name: 'emailTemplateRevisionSalesCopy',
        params: { id: $route.params.id, revisionid: $route.params.revisionid }
      }"
      ><v-icon>content_copy</v-icon>Copy</v-btn
    >
    <div v-if="copy.published" style="color: red">Published</div>
    <v-form ref="formEmailTemplateRevision" v-model="valid" lazy-validation>
      <v-text-field
        label="Id"
        v-model="copy.id"
        outline
        readonly
        v-if="$route.params.revisionid"
      />
      <v-text-field
        label="Subject"
        v-model="copy.subject"
        :rules="valueRules"
        outline
      />
      <v-select
        item-text="name"
        item-value="id"
        v-model="selectedTypes"
        :items="quoteTypes"
        :menu-props="{ maxHeight: '400' }"
        label="Quote types"
        multiple
        chips
        outline
      />
      <v-select
        item-text="name"
        item-value="id"
        v-model="copy.instructed"
        :items="instructeds"
        label="Instruction level"
        outline
      />
      <v-checkbox
        label="Callback (Sent when callback requested)"
        v-model="copy.callback"
      />
      <v-checkbox
        label="Exclude offers (Sent when unsubscribe triggered)"
        v-model="copy.excludeoffers"
      />
      <v-checkbox
        label="Instruction confirmation submitted (Sent when IC submitted)"
        v-model="copy.instructionConfirmationSubmitted"
      />
      <v-checkbox
        label="Send a copy of the email to sales"
        v-model="copy.copySales"
      />
      <v-checkbox
        label="Send automatically"
        v-model="copy.sendAutomatically"
        @change="validateSchedule"
      />
      <v-text-field
        type="number"
        label="Schedule (days)"
        v-model.number="copy.schedule"
        v-if="copy.sendAutomatically"
        :rules="scheduleValidation"
        @keyup="validateSchedule"
        outline
        required
      />
      <v-btn @click="saveEmailTemplateRevision">Save</v-btn>
    </v-form>
    <div v-if="$route.params.revisionid">
      <h2>Email sections</h2>
      <v-btn @click="addSection = 1"><v-icon>add</v-icon> Add</v-btn>
      <div class="ajaxForm" v-if="addSection != 0">
        <div v-if="addSection == 1">
          <v-btn @click="addSection = 2"
            ><v-icon>add</v-icon> Add email template</v-btn
          >
          <v-btn @click="addSection = 3"
            ><v-icon>add</v-icon> Add email panel</v-btn
          >
          <v-btn @click="createSection(0)"
            ><v-icon>add</v-icon> Add quotation</v-btn
          >
          <v-btn @click="createSection(3)"
            ><v-icon>add</v-icon> Add additional</v-btn
          >
        </div>
        <div v-if="addSection == 2">
          <h3>Choose email template</h3>
          <v-select
            item-text="name"
            item-value="id"
            v-model="tag"
            :items="tags"
            label="Email template tag"
            outline
          />
          <v-select
            item-text="name"
            item-value="id"
            v-model="emailTemplateId"
            :items="emailTemplates"
            label="Email template"
            outline
          />
          <template v-if="emailTemplate">
            <v-text-field
              label="Subject"
              v-model="emailTemplate.subject"
              outline
              readonly
            />
            <div v-html="emailTemplate.body" />
            <v-btn @click="createSection(1, emailTemplate.id)"
              ><v-icon>add</v-icon> Add template</v-btn
            >
          </template>
        </div>
        <div v-if="addSection == 3 && this.emailPanels">
          <h3>Choose email panel</h3>
          <div v-for="emailPanel in emailPanels" :key="emailPanel.id">
            <v-btn @click="createSection(2, emailPanel.id)"
              ><v-icon>add</v-icon> Add panel</v-btn
            >
            <EmailPanel :value="emailPanel" />
          </div>
        </div>
        <hr />
        <v-btn @click="addSection = 0">Cancel</v-btn>
      </div>
      <div
        v-for="emailSection in emailTemplateRevisionSales.emailTemplateSections"
        :key="emailSection.id"
        style="padding: 20px; border: 1px solid black"
      >
        <a @click="moveSection(emailSection, true)">Up</a
        ><span>&#160;|&#160;</span>
        <a @click="moveSection(emailSection, false)">Down</a
        ><span>&#160;|&#160;</span>
        <a @click="deleteSection(emailSection)">Delete</a>
        <div v-if="emailSection.type == 0">
          <h1>Quotation</h1>
          <LoremIpsum add="1p" />
        </div>
        <div
          v-if="emailSection.type == 1"
          v-html="emailSection.emailTemplate.body"
        />
        <EmailPanel
          :value="emailSection.emailTemplatePanel"
          v-if="emailSection.type == 2"
        />
        <div v-if="emailSection.type == 3">
          <h1>Additional</h1>
          <LoremIpsum add="1p" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoremIpsum from "vue-lorem-ipsum";
import EmailPanel from "@/components/quote/emailPanel/EmailPanel";
import nbmlaw from "@/api/nbmlaw";
import { instructedList } from "@/util/helpers";
export default {
  name: "EmailTemplateRevision",
  metaInfo() {
    return {
      title: "Email Template Revision",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    EmailPanel,
    LoremIpsum
  },
  data() {
    return {
      quoteTypes: null,
      emailTemplates: null,
      emailTemplate: null,
      emailTemplateId: null,
      emailTemplateRevisionSales: null,
      emailPanels: null,
      copy: null,
      valueRules: [(v) => v != undefined || "Value is required"],
      scheduleValidation: [true],
      valid: false,
      selectedTypes: [],
      tags: ["sales_offers", "sales_quotes"],
      tag: "sales_offers",
      instructeds: null,
      addSection: 0
    };
  },
  methods: {
    async fetchQuoteTypes() {
      const response = await nbmlaw.get(`/cors/admin/sales/quoteTypes`);
      // console.log(response.data);
      this.quoteTypes = response.data;
    },
    async fetchEmailTemplates() {
      const response = await nbmlaw.get(
        `/cors/admin/document/emailTemplates/tags/${this.tag}`
      );
      // console.log(response.data);
      this.emailTemplates = response.data;
    },
    async fetchEmailPanels() {
      const response = await nbmlaw.get(`/cors/admin/sales/emailPanels`);
      //   console.log(response.data);
      this.emailPanels = response.data;
    },
    async fetchEmailTemplateRevisionSales() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/emailTemplateRevisions/${this.$route.params.revisionid}`
      );
      // console.log(response.data);
      this.emailTemplateRevisionSales = response.data;
    },
    saveEmailTemplateRevision() {
      if (this.$refs.formEmailTemplateRevision.validate()) {
        if (this.$route.params.revisionid) {
          this.updateEmailTemplateRevision();
        } else {
          this.createEmailTemplateRevision();
        }
      }
    },
    async createEmailTemplateRevision() {
      await nbmlaw.post(
        `/cors/admin/sales/emailTemplates/${this.$route.params.id}/emailTemplateRevisions`,
        {
          copy: this.copy,
          selectedTypes: this.selectedTypes
        }
      );
      this.$router.push({
        name: "emailTemplateSales",
        params: { id: this.$route.params.id }
      });
    },
    async updateEmailTemplateRevision() {
      try {
        await nbmlaw.put(
          `/cors/admin/sales/emailTemplateRevisions/${this.$route.params.revisionid}`,
          {
            copy: this.copy,
            selectedTypes: this.selectedTypes
          }
        );
        this.$router.push({
          name: "emailTemplateSales",
          params: { id: this.$route.params.id }
        });
      } catch (err) {
        alert(err.response.data);
      }
    },
    async createSection(type, value) {
      try {
        await nbmlaw.post(
          `/cors/admin/sales/emailTemplateRevisions/${this.$route.params.revisionid}/emailSections`,
          { type, value }
        );
        this.addSection = 0;
        this.fetchEmailTemplateRevisionSales();
      } catch (err) {
        alert(err.response.data);
      }
    },
    async moveSection(section, up) {
      try {
        await nbmlaw.put(
          `/cors/admin/sales/emailTemplateRevisions/${this.$route.params.revisionid}/emailSections/${section.id}`,
          null,
          { params: { up } }
        );
        this.fetchEmailTemplateRevisionSales();
      } catch (err) {
        alert(err.response.data);
      }
    },
    async deleteSection(section) {
      if (confirm("Are you sure?")) {
        try {
          await nbmlaw.delete(
            `/cors/admin/sales/emailTemplateRevisions/${this.$route.params.revisionid}/emailSections/${section.id}`
          );
          this.fetchEmailTemplateRevisionSales();
        } catch (err) {
          alert(err.response.data);
        }
      }
    },
    async publish() {
      if (confirm("Are you sure?")) {
        await nbmlaw.put(
          `/cors/admin/sales/emailTemplateRevisions/${this.$route.params.revisionid}/publish`,
          null
        );
        this.$router.push({
          name: "emailTemplateSales",
          params: { id: this.$route.params.id }
        });
      }
    },
    validateSchedule() {
      const empty =
        this.copy.schedule === undefined ||
        this.copy.schedule === null ||
        this.copy.schedule === "";
      if (this.copy.sendAutomatically && empty) {
        this.scheduleValidation = ["Schedule must have a numeric value"];
        return;
      }
      if (!this.copy.sendAutomatically && empty) {
        this.copy.schedule = 0;
        return;
      }
      if (!Number.isInteger(this.copy.schedule)) {
        this.scheduleValidation = ["Number must be an integer"];
        return;
      }
      this.scheduleValidation = [true];
    }
  },
  watch: {
    "$route.params.revisionid": {
      immediate: true,
      handler() {
        if (this.$route.params.revisionid) {
          this.fetchEmailTemplateRevisionSales();
        } else {
          this.copy = {
            instructed: 2,
            name: "NEW NAME",
            sendAutomatically: false,
            showCallback: true
          };
          this.selectedTypes = [];
        }
      }
    },
    emailTemplateRevisionSales: {
      handler() {
        if (this.emailTemplateRevisionSales) {
          this.copy = JSON.parse(
            JSON.stringify(this.emailTemplateRevisionSales)
          );
          this.selectedTypes = this.emailTemplateRevisionSales.quoteTypes.map(
            (qt) => qt.id
          );
        }
      }
    },
    emailTemplateId: {
      handler() {
        this.emailTemplate = this.emailTemplates.find(
          (et) => et.id == this.emailTemplateId
        );
      }
    },
    tag: {
      immediate: true,
      handler() {
        this.fetchEmailTemplates();
      }
    },
    addSection: {
      handler() {
        if (this.addSection == 3) {
          this.fetchEmailPanels();
        }
      }
    }
  },
  created() {
    this.fetchQuoteTypes();
    this.instructeds = instructedList();
  }
};
</script>